import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import {
  findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum,
  findFaqByLanguageResponseDtoCategoryEnum,
  useFindFaqByLanguage,
} from "~/gen/api"
import { i18n } from "~/i18n"
import { FAQContent } from "~/pages/Brand/FAQ/FAQContent.tsx"

export const SupplierFAQ = () => {
  const lang = i18n.language
    .split("-")[0]
    .toUpperCase() as keyof typeof findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum

  const faqQuery = useFindFaqByLanguage(
    findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum[lang]
  )

  return (
    <DataFetchWrapper query={faqQuery}>
      {({ data }) => (
        <FAQContent
          faqs={data.data.filter(
            (faq) =>
              faq.category ===
              findFaqByLanguageResponseDtoCategoryEnum.SUPPLIERS
          )}
        />
      )}
    </DataFetchWrapper>
  )
}
